export const required = value =>
  value === undefined || value === null || value === '' ? 'Required' : undefined

export const zeroRequired = value =>
  value || value === 0 ? undefined : 'Required'

export const number = value =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined

export const sumMustBe = (fields, sumValue) => (value, allValues) => {
  const sum = fields.reduce((s, f) => s + parseFloat(allValues[f], 10), 0)
  return sum !== sumValue ? 'The sum must be 100%' : undefined
}

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined

export const betweenNumbers = (min, max) => value =>
  value >= min && value <= max
    ? undefined
    : `The value must be between ${min} - ${max}`

export const minValue = minValue => value =>
  value && value.trim().length >= minValue
    ? undefined
    : `The min value is ${minValue}`

export const maxValue = maxValue => value =>
  value && value.trim().length <= maxValue
    ? undefined
    : `The max value is ${maxValue}`

export const string = value =>
  value && /^[A-z]+$/gi.test(value) ? undefined : 'Must be a string'

/**
 * Check input to be a string of comma-separated numbers.
 *  Returns undefined for valid value, or string with error message for invalid one
 * @example
 * '1,2'// valid
 * '1'// valid
 * '' //valid
 * ',,,' //valid
 * '1,2,cat' // invalid
 * @param {string} value value to be validate
 * @returns {string|undefined}
 */
export const commaSeparatedNumbers = value =>
  value &&
  value
    .split(',')
    .filter(num => num.length > 0)
    .every(num => !isNaN(num))
    ? undefined
    : 'Must be a comma-separated list of numbers'

/**
 * Check input to be a string of comma-separated values with at least 1 value.
 *  Returns undefined for valid value, or string with error message for invalid one
 * @example
 * `foo,bar`// valid
 * `,,foo` //valid
 * `` // invalid
 * `,,,` //invalid
 * @param {string} value value to be validate
 * @returns {string|undefined}
 */
export const requiredCommaSeparatedValues = value =>
  value && value.split(',').filter(val => val.length > 0).length > 0
    ? undefined
    : 'Required'

export const minNumberValue = minValue => value =>
  value && value >= minValue ? undefined : `The min value is ${minValue}`

export const roundNumber = number =>
  number && String(number).includes('.') ? `Round numbers only` : undefined



// WEBPACK FOOTER //
// ./src/Utils/Validators/formValidation.js